import { Injectable } from '@angular/core';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { Observable } from 'rxjs';
import { RecordsODCCommand } from '../command/records-odc.command';
import { FilesBillingCommand } from '../command/get-files-billing.command';
import { PdfGuideCommand } from '../command/get-pdf-guide.command';
import { GetDetailODCCommand } from '../command/get-detail-odc.command';
import { GetDetailODCStringCommand } from '../command/get-detail-odc-string.command';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(public requestService: HttpRequestService) { }

  /**
   * * Mehtod for get all orders
   * *
   * * @returns
   * */
  getRecordsODC(command: RecordsODCCommand, pageNumber: number, pageSize: number): Observable<HttpServerResponse<any>> {
    command.pageNumber = pageNumber;
    command.pageSize = pageSize;
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetrowsODC, command);
  }

  /**
   * * Mehtod for get files for biling
   *
   * @returns
   * */
  getFilesBilling(command: FilesBillingCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetFilesbilling, command);
  }

  /**
   * Metodo para traer las guias pdf
   *
   * @returns
   */
  getPdfGuide(command: PdfGuideCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetPdfGuide, command);
  }

  /**
   * Metodo para traer el detalle de la orden de compra
   *
   * @returns
   */
  getPDetailODC(command: GetDetailODCCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetDetailODC, command);
  }
   /**
   * Metodo para traer el detalle de la orden de compra
   *
   * @returns
   */
   getPDetailODCResumen(command: GetDetailODCStringCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.DetailOdc, command);
  }

}
